module.exports = __webpack_public_path__ + "images/emoji/curry.0348079ee7929b43cc56.png";